export default __webpack_public_path__ + "static/media/light_01.e97eb3f8.svg";